import { client } from "api";
import { User } from "features/auth/types/user";

export type GetUserStatisticsRequest = { userId: string };

export type GetUserStatisticsResponse = User[];

export const getUserStatistics = ({
  userId,
}: GetUserStatisticsRequest): Promise<GetUserStatisticsResponse> =>
  client.get<GetUserStatisticsResponse>(`/user/user-statistics/${userId}`).then((res) => res.data);
